import gql from "graphql-tag";
import React from "react";
import { useQuery } from "react-apollo-hooks";
import { useParams } from "react-router";
import ReactTable from "react-table-v6";
import { Label, Row, Card, CardBody, FormGroup } from "reactstrap";
import Col from "reactstrap/lib/Col";
import Input from "reactstrap/lib/Input";
import moment from "moment";
import { CustomOptimum } from "./components/CustomOptimum";
import { CustomResults } from "./components/CustomResults";

const query = gql`
  query getRegisteredPatientByPatient($where: WhereGetRegisteredPatient) {
    registeredPatientByPatient: getRegisteredPatientByPatient(where: $where) {
      appointmentDate
      metric
      optimumLevel
      results
      controlled
      typeId
    }
    info: getInfo(where: $where) {
      activationDate
      affiliateName
      programName
    }
  }
`;

export default function Table({ state }) {
  const { programId, patientId } = useParams();
  // console.log()
  const { data } = useQuery(query, {
    variables: {
      where: {
        programId: parseInt(programId),
        patientId: parseInt(patientId)
      }
    },
    fetchPolicy: "network-only"
  });

  console.log(data);

  return (
    <Card>
      <CardBody>
        <Row>
          <Col sm={12}>
            <Label className="font-weight-bold">Métricas de Control</Label>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col sm={4}>
            <FormGroup>
              <Label>Paciente</Label>
              <Input disabled value={data.info && data.info.affiliateName} />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <Label>PAM</Label>
            <Input disabled value={data.info && data.info.programName} />
          </Col>
          <Col sm={2}>
            <FormGroup>
              <Label>Fecha de inicio</Label>
              <Input disabled value={data.info && data.info.activationDate} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="mt-2">
            <ReactTable
              data={data.registeredPatientByPatient}
              defaultPageSize={10}
              columns={[
                {
                  Header: "Ultima Cita",
                  className: "text-center",
                  accessor: "appointmentDate",
                  Cell: ({ original }) => (
                    <span>
                      {moment(original.appointmentDate).format("DD/MM/YYYY")}
                    </span>
                  )
                },
                {
                  Header: "Métrica ",
                  accessor: "metric"
                },
                {
                  Header: "Mínimo",
                  className: "text-center",
                  Cell: ({ original }) => {
                    return CustomOptimum(original, 0);
                  }
                },
                {
                  Header: "Máximo",
                  className: "text-center",
                  Cell: ({ original }) => {
                    return CustomOptimum(original, 1);
                  }
                },
                {
                  Header: "Resultado",
                  className: "text-center",
                  Cell: ({ original }) => {
                    return CustomResults(original);
                  }
                },
                {
                  Header: "Estatus",
                  accessor: "controlled",
                  Cell: ({ original: { controlled } }) => (
                    <span>{controlled ? "Controlado" : "No Controlado"}</span>
                  )
                }
              ]}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
